<script setup lang="ts">
import DarwinButton from '@/uiKit/DarwinButton.vue'
import ToolTip from '@/uiKit/ToolTip.vue'

defineEmits<{
  (e: 'skip' | 'skip-mousedown'): void
}>()
</script>

<template>
  <ToolTip
    title="Allow downstream fields to be computed even if this field is empty."
    :auto-placement-options="{ allowedPlacements: ['top', 'top-end'] }"
    :offset="2"
  >
    <DarwinButton
      size="sm"
      variant="transparent"
      class="w-full rounded-none"
      @click="$emit('skip')"
      @mousedown="$emit('skip-mousedown')"
    >
      Skip
    </DarwinButton>
  </ToolTip>
</template>
